// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-switch .v-label {
  padding-inline-start: 10px;
}

:where(.vuetify-styles) .v-switch__loader {
  display: flex;
}
:where(.vuetify-styles) .v-switch__loader .v-progress-circular {
  color: rgb(var(--v-theme-surface));
}

:where(.vuetify-styles) .v-switch__track,
:where(.vuetify-styles) .v-switch__thumb {
  transition: none;
}
:where(.vuetify-styles) .v-selection-control--error:not(.v-selection-control--disabled) .v-switch__track,
:where(.vuetify-styles) .v-selection-control--error:not(.v-selection-control--disabled) .v-switch__thumb {
  background-color: rgb(var(--v-theme-error));
  color: rgb(var(--v-theme-on-error));
}

:where(.vuetify-styles) .v-switch__track-true {
  margin-inline-end: auto;
}
:where(.vuetify-styles) .v-selection-control:not(.v-selection-control--dirty) .v-switch__track-true {
  opacity: 0;
}

:where(.vuetify-styles) .v-switch__track-false {
  margin-inline-start: auto;
}
:where(.vuetify-styles) .v-selection-control--dirty .v-switch__track-false {
  opacity: 0;
}

:where(.vuetify-styles) .v-switch__track {
  display: inline-flex;
  align-items: center;
  font-size: 0.5rem;
  padding: 0 5px;
  background-color: rgb(var(--v-theme-surface-variant));
  border-radius: 9999px;
  height: 14px;
  opacity: 0.6;
  min-width: 36px;
  cursor: pointer;
  transition: 0.2s background-color cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-switch--inset .v-switch__track {
  border-radius: 9999px;
  font-size: 0.75rem;
  height: 32px;
  min-width: 52px;
}

:where(.vuetify-styles) .v-switch__thumb {
  align-items: center;
  background-color: rgb(var(--v-theme-surface-bright));
  color: rgb(var(--v-theme-on-surface-bright));
  border-radius: 50%;
  display: flex;
  font-size: 0.75rem;
  height: 20px;
  justify-content: center;
  width: 20px;
  pointer-events: none;
  transition: 0.15s 0.05s transform cubic-bezier(0, 0, 0.2, 1), 0.2s color cubic-bezier(0.4, 0, 0.2, 1), 0.2s background-color cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
:where(.vuetify-styles) .v-switch:not(.v-switch--inset) .v-switch__thumb {
  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-switch.v-switch--flat:not(.v-switch--inset) .v-switch__thumb {
  background: rgb(var(--v-theme-surface-variant));
  color: rgb(var(--v-theme-on-surface-variant));
}
:where(.vuetify-styles) .v-switch.v-switch--flat:not(.v-switch--inset) .v-switch__thumb {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-switch--inset .v-switch__thumb {
  height: 24px;
  width: 24px;
  transform: scale(0.6666666667);
}
:where(.vuetify-styles) .v-switch--inset .v-switch__thumb--filled {
  transform: none;
}
:where(.vuetify-styles) .v-switch--inset .v-selection-control--dirty .v-switch__thumb {
  transform: none;
  transition: 0.15s 0.05s transform cubic-bezier(0, 0, 0.2, 1);
}

:where(.vuetify-styles) .v-switch.v-input {
  flex: 0 1 auto;
}
:where(.vuetify-styles) .v-switch .v-selection-control {
  min-height: var(--v-input-control-height);
}
:where(.vuetify-styles) .v-switch .v-selection-control__input {
  border-radius: 50%;
  transition: 0.2s transform cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
}
:where(.vuetify-styles) .v-locale--is-ltr.v-switch .v-selection-control__input, :where(.vuetify-styles) .v-locale--is-ltr .v-switch .v-selection-control__input {
  transform: translateX(-10px);
}

:where(.vuetify-styles) .v-locale--is-rtl.v-switch .v-selection-control__input, :where(.vuetify-styles) .v-locale--is-rtl .v-switch .v-selection-control__input {
  transform: translateX(10px);
}

:where(.vuetify-styles) .v-switch .v-selection-control__input .v-icon {
  position: absolute;
}
:where(.vuetify-styles) .v-locale--is-ltr.v-switch .v-selection-control--dirty .v-selection-control__input, :where(.vuetify-styles) .v-locale--is-ltr .v-switch .v-selection-control--dirty .v-selection-control__input {
  transform: translateX(10px);
}

:where(.vuetify-styles) .v-locale--is-rtl.v-switch .v-selection-control--dirty .v-selection-control__input, :where(.vuetify-styles) .v-locale--is-rtl .v-switch .v-selection-control--dirty .v-selection-control__input {
  transform: translateX(-10px);
}

:where(.vuetify-styles) .v-switch.v-switch--indeterminate .v-selection-control__input {
  transform: scale(0.8);
}
:where(.vuetify-styles) .v-switch.v-switch--indeterminate .v-switch__thumb {
  transform: scale(0.75);
  box-shadow: none;
}
:where(.vuetify-styles) .v-switch.v-switch--inset .v-selection-control__wrapper {
  width: auto;
}
:where(.vuetify-styles) .v-switch.v-input--vertical .v-label {
  min-width: max-content;
}
:where(.vuetify-styles) .v-switch.v-input--vertical .v-selection-control__wrapper {
  transform: rotate(-90deg);
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-switch .v-switch__loader .v-progress-circular {
    color: currentColor;
  }
  :where(.vuetify-styles) .v-switch .v-switch__thumb {
    background-color: buttontext;
  }
  :where(.vuetify-styles) .v-switch .v-switch__track,
  :where(.vuetify-styles) .v-switch .v-switch__thumb {
    border: 1px solid;
    color: buttontext;
  }
  :where(.vuetify-styles) .v-switch:not(.v-switch--loading):not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {
    background-color: highlight;
  }
  :where(.vuetify-styles) .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__track {
    background-color: highlight;
  }
  :where(.vuetify-styles) .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__track,
  :where(.vuetify-styles) .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {
    color: highlight;
  }
  :where(.vuetify-styles) .v-switch.v-switch--inset .v-switch__track {
    border-width: 2px;
  }
  :where(.vuetify-styles) .v-switch.v-switch--inset:not(.v-switch--loading):not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {
    background-color: highlighttext;
    color: highlighttext;
  }
  :where(.vuetify-styles) .v-switch.v-input--disabled .v-switch__thumb {
    background-color: graytext;
  }
  :where(.vuetify-styles) .v-switch.v-input--disabled .v-switch__track,
  :where(.vuetify-styles) .v-switch.v-input--disabled .v-switch__thumb {
    color: graytext;
  }
  :where(.vuetify-styles) .v-switch.v-switch--loading .v-switch__thumb {
    background-color: canvas;
  }
  :where(.vuetify-styles) .v-switch.v-switch--loading.v-switch--inset .v-switch__thumb, :where(.vuetify-styles) .v-switch.v-switch--loading.v-switch--indeterminate .v-switch__thumb {
    border-width: 0;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSwitch/VSwitch.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,yJAAyJ;EACzJ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wOAAwO;AAC1O;AACA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,sOAAsO;AACxO;AACA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,4DAA4D;AAC9D;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,uDAAuD;EACvD,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".v-switch .v-label {\n  padding-inline-start: 10px;\n}\n\n.v-switch__loader {\n  display: flex;\n}\n.v-switch__loader .v-progress-circular {\n  color: rgb(var(--v-theme-surface));\n}\n\n.v-switch__track,\n.v-switch__thumb {\n  transition: none;\n}\n.v-selection-control--error:not(.v-selection-control--disabled) .v-switch__track,\n.v-selection-control--error:not(.v-selection-control--disabled) .v-switch__thumb {\n  background-color: rgb(var(--v-theme-error));\n  color: rgb(var(--v-theme-on-error));\n}\n\n.v-switch__track-true {\n  margin-inline-end: auto;\n}\n.v-selection-control:not(.v-selection-control--dirty) .v-switch__track-true {\n  opacity: 0;\n}\n\n.v-switch__track-false {\n  margin-inline-start: auto;\n}\n.v-selection-control--dirty .v-switch__track-false {\n  opacity: 0;\n}\n\n.v-switch__track {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.5rem;\n  padding: 0 5px;\n  background-color: rgb(var(--v-theme-surface-variant));\n  border-radius: 9999px;\n  height: 14px;\n  opacity: 0.6;\n  min-width: 36px;\n  cursor: pointer;\n  transition: 0.2s background-color cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-switch--inset .v-switch__track {\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  height: 32px;\n  min-width: 52px;\n}\n\n.v-switch__thumb {\n  align-items: center;\n  background-color: rgb(var(--v-theme-surface-bright));\n  color: rgb(var(--v-theme-on-surface-bright));\n  border-radius: 50%;\n  display: flex;\n  font-size: 0.75rem;\n  height: 20px;\n  justify-content: center;\n  width: 20px;\n  pointer-events: none;\n  transition: 0.15s 0.05s transform cubic-bezier(0, 0, 0.2, 1), 0.2s color cubic-bezier(0.4, 0, 0.2, 1), 0.2s background-color cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n.v-switch:not(.v-switch--inset) .v-switch__thumb {\n  box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-switch.v-switch--flat:not(.v-switch--inset) .v-switch__thumb {\n  background: rgb(var(--v-theme-surface-variant));\n  color: rgb(var(--v-theme-on-surface-variant));\n}\n.v-switch.v-switch--flat:not(.v-switch--inset) .v-switch__thumb {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-switch--inset .v-switch__thumb {\n  height: 24px;\n  width: 24px;\n  transform: scale(0.6666666667);\n}\n.v-switch--inset .v-switch__thumb--filled {\n  transform: none;\n}\n.v-switch--inset .v-selection-control--dirty .v-switch__thumb {\n  transform: none;\n  transition: 0.15s 0.05s transform cubic-bezier(0, 0, 0.2, 1);\n}\n\n.v-switch.v-input {\n  flex: 0 1 auto;\n}\n.v-switch .v-selection-control {\n  min-height: var(--v-input-control-height);\n}\n.v-switch .v-selection-control__input {\n  border-radius: 50%;\n  transition: 0.2s transform cubic-bezier(0.4, 0, 0.2, 1);\n  position: absolute;\n}\n.v-locale--is-ltr.v-switch .v-selection-control__input, .v-locale--is-ltr .v-switch .v-selection-control__input {\n  transform: translateX(-10px);\n}\n\n.v-locale--is-rtl.v-switch .v-selection-control__input, .v-locale--is-rtl .v-switch .v-selection-control__input {\n  transform: translateX(10px);\n}\n\n.v-switch .v-selection-control__input .v-icon {\n  position: absolute;\n}\n.v-locale--is-ltr.v-switch .v-selection-control--dirty .v-selection-control__input, .v-locale--is-ltr .v-switch .v-selection-control--dirty .v-selection-control__input {\n  transform: translateX(10px);\n}\n\n.v-locale--is-rtl.v-switch .v-selection-control--dirty .v-selection-control__input, .v-locale--is-rtl .v-switch .v-selection-control--dirty .v-selection-control__input {\n  transform: translateX(-10px);\n}\n\n.v-switch.v-switch--indeterminate .v-selection-control__input {\n  transform: scale(0.8);\n}\n.v-switch.v-switch--indeterminate .v-switch__thumb {\n  transform: scale(0.75);\n  box-shadow: none;\n}\n.v-switch.v-switch--inset .v-selection-control__wrapper {\n  width: auto;\n}\n.v-switch.v-input--vertical .v-label {\n  min-width: max-content;\n}\n.v-switch.v-input--vertical .v-selection-control__wrapper {\n  transform: rotate(-90deg);\n}\n\n@media (forced-colors: active) {\n  .v-switch .v-switch__loader .v-progress-circular {\n    color: currentColor;\n  }\n  .v-switch .v-switch__thumb {\n    background-color: buttontext;\n  }\n  .v-switch .v-switch__track,\n  .v-switch .v-switch__thumb {\n    border: 1px solid;\n    color: buttontext;\n  }\n  .v-switch:not(.v-switch--loading):not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {\n    background-color: highlight;\n  }\n  .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__track {\n    background-color: highlight;\n  }\n  .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__track,\n  .v-switch:not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {\n    color: highlight;\n  }\n  .v-switch.v-switch--inset .v-switch__track {\n    border-width: 2px;\n  }\n  .v-switch.v-switch--inset:not(.v-switch--loading):not(.v-input--disabled) .v-selection-control--dirty .v-switch__thumb {\n    background-color: highlighttext;\n    color: highlighttext;\n  }\n  .v-switch.v-input--disabled .v-switch__thumb {\n    background-color: graytext;\n  }\n  .v-switch.v-input--disabled .v-switch__track,\n  .v-switch.v-input--disabled .v-switch__thumb {\n    color: graytext;\n  }\n  .v-switch.v-switch--loading .v-switch__thumb {\n    background-color: canvas;\n  }\n  .v-switch.v-switch--loading.v-switch--inset .v-switch__thumb, .v-switch.v-switch--loading.v-switch--indeterminate .v-switch__thumb {\n    border-width: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
